// Unpublished Work © 2021-2026 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';

function Container(props) {
    const {children} = props;

    return (
        <>
            <div className='onlink-tile onequip-tile data-grid-tile'>
                {children}
            </div>
        </>
    );
}

Container.propTypes = {
    children: PropTypes.node
};

export default Container;
